import { useCallback, useEffect, useState } from "react";
import { RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { api, getSyncState } from "@/lib/sync";
import { applyServerCategories } from "@/lib/store";


const daysLeft = (iso, days) => Math.max(1, days - Math.floor((Date.now() - new Date(iso).getTime()) / 86400000));

// "Recently deleted" categories, restorable for 30 days.
export const CategoryTrash = () => {
  const [trash, setTrash] = useState({ days: 30, items: [] });
  const [busy, setBusy] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/planner/categories/trash");
      setTrash(data);
    } catch {}
  }, []);

  useEffect(() => {
    load();
    const onSync = (e) => {
      const s = e.detail || getSyncState();
      if (s.pending === 0 && !s.syncing) load();
    };
    window.addEventListener("tl:sync-state", onSync);
    return () => window.removeEventListener("tl:sync-state", onSync);
  }, [load]);

  async function restore(item) {
    setBusy(item.id);
    try {
      const { data } = await api.post(`/planner/categories/${encodeURIComponent(item.id)}/restore`);
      applyServerCategories(data.categories);
      setTrash((t) => ({ ...t, items: t.items.filter((i) => i.id !== item.id) }));
      toast.success(`"${item.name}" ripristinata`);
    } catch {
      toast.error("Non riesco a ripristinarla ora, riprova tra poco");
    } finally {
      setBusy(null);
    }
  }

  if (!trash.items.length) return null;
  return (
    <div className="mt-5 pt-4 border-t border-dashed border-[#E4E7E1]" data-testid="category-trash">
      <div className="tl-label mb-1">Eliminate di recente</div>
      <p className="text-xs text-[#6A7368] mb-3">Puoi ripristinarle entro {trash.days} giorni. Le attività collegate tornano al loro posto.</p>
      <ul className="flex flex-col gap-2">
        {trash.items.map((item) => (
          <li key={item.id} className="flex items-center gap-3" data-testid={`category-trash-item-${item.id}`}>
            <span className="w-4 h-4 rounded-full flex-shrink-0 border border-[#E4E7E1]" style={{ background: item.color }} />
            <span className="flex-1 min-w-0 truncate text-sm text-[#58635B]">{item.name}</span>
            <span className="text-[11px] text-[#6A7368] whitespace-nowrap">ancora {daysLeft(item.deleted_at, trash.days)} gg</span>
            <button
              type="button"
              onClick={() => restore(item)}
              disabled={busy === item.id}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-[#A3B897] text-[#58635B] text-xs font-medium hover:bg-[#F3F5F0] transition-colors disabled:opacity-50"
              data-testid={`category-restore-${item.id}`}
            >
              <RotateCcw size={12} strokeWidth={1.75} /> Ripristina
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
